import { render, staticRenderFns } from "./404.vue?vue&type=template&id=5df0a51b"
import script from "./404.js?vue&type=script&lang=js&external"
export * from "./404.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports